export const MessageTypeEnum = {
    INFORMATIVE: 1,
    EXCLAMATION: 2,
    CRITICAL: 3,
    QUESTION: 4
};

export const ButtonGroupEnum = {
    OK_CANCEL: 1,
    OK: 2,
    YES_NO: 3,
    YES_NO_CANCEL: 4
};

export const ButtonMessageEnum = {
    OK: "OK",
    CANCEL: "Zrušiť",
    YES: "Áno",
    NO: "Nie"
};

export const ValueTypeEnum = {
    TEXT: 1,
    NUMBER: 2,
    DATE: 3,
    DATETIME: 4
};

export const PotvrdenieStavEnum = {
    NIC: 0,
    OK: 1,
    CHYBA: 2,
    NAVIAC: 3,
    ROZDIEL: 4,
    ZAMENA: 5
};

export const RoleNames = {
    Administrator: "Administrator",
    Vyvojar: "Vyvojar"
};

export const LogLevel = {
    Trace: 0,
    Debug: 1,
    Information: 2,
    Warning: 3,
    Error: 4,
    Critical: 5,
    None: 6
};

export const CiarovyKodAllowedHandleKeys = [
    "numeric",
    "enter",
    "shift"
    // "shift+0",
    // "shift+1",
    // "shift+2",
    // "shift+3",
    // "shift+4",
    // "shift+5",
    // "shift+6",
    // "shift+7",
    // "shift+8",
    // "shift+9"
];

export const TypTovaru = {
    P: "P", // Presun
    P1: "P1",
    P2: "P2",
    P3: "P3",
    PE: "PE",
    V: "V",
    ZR: "ZR",
    SR: "SR",
    M: "M", // Materiálový balík

    D: "D", // Dachser
    R: "R", // Kontejnerový balík z HS Ružomberok - logika jako Dachser
    S: "S", // HS Sereď - logika jako Dachser
    X: "X",
};

export const SposobDopravy = {
    GLS: "GLS"
};



// WEBPACK FOOTER //
// ./src/enums/index.js